<div class="form" [formGroup]="formGroup">
  <div>
    <span>{{ 'Old password' | translate }} *</span>
    <tui-textfield [tuiTextfieldCleaner]="false">
      <input
        tuiTextfield
        type="password"
        translate="no"
        autocomplete="current-password"
        formControlName="oldPassword"
        [invalid]="
          formGroup.controls['oldPassword'].invalid && formGroup.controls['oldPassword'].touched
        "
        [placeholder]="'Enter old password' | translate"
      />
      <tui-icon tuiPassword />
    </tui-textfield>
    <tui-error [error]="formGroup.get('oldPassword')?.errors?.['message']" />
  </div>
  <div>
    <span>{{ 'New password' | translate }} *</span>
    <tui-textfield [tuiTextfieldCleaner]="false">
      <input
        tuiTextfield
        type="password"
        translate="no"
        autocomplete="new-password"
        formControlName="newPassword"
        [invalid]="
          formGroup.controls['newPassword'].invalid && formGroup.controls['newPassword'].touched
        "
        [placeholder]="'Enter new password' | translate"
      />
      <tui-icon tuiPassword />
    </tui-textfield>
    <tui-error [error]="formGroup.get('newPassword')?.errors?.['message']" />

    @if (formGroup.get('newPassword')?.errors?.['minlength']) {
      <tui-error [error]="'Minimum length 6 characters' | translate" />
    }
  </div>
  <div>
    <span>{{ 'Confirm new password' | translate }} *</span>
    <tui-textfield [tuiTextfieldCleaner]="false">
      <input
        tuiTextfield
        type="password"
        translate="no"
        autocomplete="new-password"
        formControlName="confirmPassword"
        [invalid]="
          formGroup.controls['confirmPassword'].invalid &&
          formGroup.controls['confirmPassword'].touched
        "
        [placeholder]="'Enter your new password again' | translate"
      />
      <tui-icon tuiPassword />
    </tui-textfield>
    <tui-error [error]="formGroup.get('confirmPassword')?.errors?.['message']" />

    @if (
      formGroup.get('confirmPassword')?.errors?.['mismatch'] &&
      formGroup.controls['confirmPassword'].touched
    ) {
      <tui-error [error]="'Password mismatch' | translate" />
    }
  </div>
</div>
<div class="btn-block">
  <button tuiButton type="button" appearance="outline" (click)="onCancel()">
    {{ 'Cancel' | translate }}
  </button>
  <button tuiButton (click)="onSave()">
    {{ 'SAVE' | translate }}
  </button>
</div>
